import request from '@/lib/request/'

const baseUri = 'auth'

/**
 * @param data {Object}
 * @returns {Promise}
 */
export function post (data) {
  return request({
    url: baseUri,
    method: 'post',
    data,
    qs: true
  })
}

/**
 * @returns {Promise}
 */
export function get () {
  return request({
    url: baseUri,
    method: 'get'
  })
}

/**
 * @returns {Promise}
 */
export function del () {
  return request({
    url: baseUri,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/auth/index.js